// extracted by mini-css-extract-plugin
module.exports = {"description":"ConfirmPasswordForm_description__2nI7B","passwordInputContainer":"ConfirmPasswordForm_passwordInputContainer__11Y_G"};